module.exports = __webpack_public_path__ + "static/media/Step1.f414f83e.svg";